"use client";

import { c as _c } from "react/compiler-runtime";
import { memo } from "react";
import TokenChainDropdown from "./TokenChainDropdown";
interface TokenChainInputProps {
  tokenAddress: string;
  chainId: number;
  onTokenChange: (address: string, chainId: number, symbol: string, decimals: number) => void;
  label?: string;
  popoverModal?: boolean;
  workflowWalletAddress?: string;
  /** When true, hides native coins (ETH, etc.) from the token dropdown */
  excludeNative?: boolean;
}
export default memo(function TokenChainInput(t0) {
  const $ = _c(12);
  const {
    tokenAddress,
    chainId,
    onTokenChange,
    label,
    popoverModal: t1,
    workflowWalletAddress,
    excludeNative: t2
  } = t0;
  const popoverModal = t1 === undefined ? false : t1;
  const excludeNative = t2 === undefined ? false : t2;
  let t3;
  if ($[0] !== label) {
    t3 = label && <label className="field-label mb-1.5 block">{label}</label>;
    $[0] = label;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  let t4;
  if ($[2] !== chainId || $[3] !== excludeNative || $[4] !== onTokenChange || $[5] !== popoverModal || $[6] !== tokenAddress || $[7] !== workflowWalletAddress) {
    t4 = <TokenChainDropdown tokenAddress={tokenAddress} chainId={chainId} onTokenChange={onTokenChange} popoverModal={popoverModal} workflowWalletAddress={workflowWalletAddress} excludeNative={excludeNative}>{_temp}</TokenChainDropdown>;
    $[2] = chainId;
    $[3] = excludeNative;
    $[4] = onTokenChange;
    $[5] = popoverModal;
    $[6] = tokenAddress;
    $[7] = workflowWalletAddress;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== t3 || $[10] !== t4) {
    t5 = <div>{t3}{t4}</div>;
    $[9] = t3;
    $[10] = t4;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  return t5;
});
function _temp(pill) {
  return <div className="border-ds-border-default hover:border-ds-neutral-300 bg-ds-surface-card flex h-[52px] w-full items-center rounded-xl border px-1.5 transition-colors dark:hover:border-zinc-600 [&>button]:w-full [&>button]:justify-between">{pill}</div>;
}